const mEditionAcademyAutorespondersModalDelete = {
  mEditionAcademyAutorespondersModalDelete: {
    alerts: {
      deleteAcademiaAutoresponder: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'La cuenta de autoresponder asociada se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará la asociación de la cuenta de autoresponder',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Cuenta'
  }
}

export default mEditionAcademyAutorespondersModalDelete
